<template>
  <div id="maps-page">
    <page-header-component v-if="topics" icon="bi bi-map" title="Peta" @filterChange="filterChange" :topics="topics"
      :hideValidate="false" isType="medkon"
      tooltip="Peta: Berita yang terdapat pada halaman ini hanya berasal dari Media Online" />
    <div class="row">
      <!-- <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 mb-1 px-gap" v-if="display_tipe == 3">
        <div id="tab" class="widget-12 card card-default widget-loader-circle shade">
          <div class="card-body">
            <ul class="nav nav-tabs nav-tabs-simple d-md-flex d-lg-flex d-xl-flex" role="tablist"
              data-init-reponsive-tabs="dropdownfx">
              <li class="nav-item" @click="switchTab('Medkon')" v-if="display_tipe == 2 || display_tipe == 3">
                <a class="active" data-toggle="tab" role="tab" data-target="#tab2hellowWorld" href="#"
                  aria-selected="true">
                  <i class="bi bi-globe-americas" /> Media Online
                </a>
              </li>
              <li class="nav-item" @click="switchTab('Medsos')" v-if="display_tipe == 1 || display_tipe == 3">
                <a href="#" data-toggle="tab" role="tab" data-target="#tab2FollowUs" class="" aria-selected="false">
                  <i class="bi bi-heart-fill text-danger" /> Media Sosial
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div> -->
      <transition name="block">
        <div v-show="mounted" class="col-md-12 col-sm-12 col-xs-12 col-lg-12 mb-1 px-gap">
          <div class="widget-12 card card-default widget-loader-circle shade">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div class="pull-left m-t-5 m-b-5">
                    <h4 class="m-b-0">
                      {{ title_map }}
                    </h4>
                    <p class="small hint-text">
                      Peta sebaran Mentions per
                      {{ this.$route.query.from | date_time_to_indo }} hingga
                      {{ this.$route.query.to | date_time_to_indo }}
                    </p>
                  </div>
                  <div class="pull-right m-t-20 d-flex align-items-center w-auto">
                    <div v-if="type_map == 'medkon'" class="ml-auto mr-2" style="width: 15rem">
                      <div class="form-group input-group input-group-right transparent m-b-0 m-t-0"
                        id="post-tier-filter">
                        <select name="sort" v-model="filter_tier" @change="filterTierChange"
                          class="form-control form-custom">
                          <option value="0">Semua Tingkat</option>
                          <option value="1">Tingkat 1</option>
                          <option value="2">Tingkat 2</option>
                          <option value="3">Tingkat 3</option>
                          <option value="4">Tingkat 4</option>
                        </select>
                        <div class="input-group-append">
                          <span class="input-group-text transparent"><i class="bi bi-stack" /></span>
                        </div>
                      </div>
                    </div>
                    <button class="btn btn-warning btn-lg mr-2" @click="switchTab(type_map_for_reset)">
                      <i class="bi bi-arrow-clockwise mr-1"></i> Reset Map
                    </button>
                    <button class="btn btn-warning btn-lg" @click="getDataExcel">
                      <i class="bi bi-filetype-xlsx mr-1"></i> Ekspor Data
                    </button>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <bubble-maps-component :key="data_key" :dataset="dataset" :mapapi="mapapi" />
                  <div class="px-2" id="top-provinsi" :class="{ 'd-none': !showPopular }">
                    <div class="py-2" v-if="top_provinsi.length > 0">
                      <p class="h5 mb-3">
                        Top 10 Provinsi dengan Mentions Terbanyak :
                      </p>
                      <div>
                        <div class="row">
                          <div v-for="(prov, index) in top_provinsi" :key="prov.nama_provinsi" class="col-md-25">
                            <div class="shadow-sm rounded mb-2">
                              <div class="d-flex pt-1 px-2">
                                <span class="mr-auto h6 font-weight-bolder">#{{ index + 1 }}
                                  {{ prov.nama_provinsi }}</span>
                                <span class="ml-auto">{{
                                  thousandSeparator(prov.count)
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="block">
        <div v-show="mounted" class="col-md-6 col-sm-12 col-xs-12 px-gap" id="popular-account"
          :class="{ 'd-none': !showCard }">
          <div class="card card-default shade">
            <div class="card-header separator">
              <div class="h6">
                Akun Terpopuler
                <span v-if="isShowProv">
                  Di <b>{{ current_prov_clicked }}</b>
                </span>
              </div>
            </div>
            <div class="card-body">
              <div v-if="isShowProv" class="table-unggahan-terbaru m-t-10">
                <table-dynamic-component :key="table_key" :data_head="data_head" :data_head_class="data_head_class"
                  :data_body="akun_data" :config="table_config" />
              </div>
              <p v-else class="m-t-10">
                Silahkan pilih salah satu provinsi pada peta terlebih dahulu
              </p>
            </div>
          </div>
        </div>
      </transition>
      <transition name="block">
        <div id="unggahan-terbaru" v-show="mounted" class="col-md-6 col-sm-12 col-xs-12 px-gap"
          :class="{ 'd-none': !showCard }">
          <div class="card card-default shade">
            <div class="card-header separator">
              <div class="h6">
                Unggahan Terbaru
                <span v-if="isShowProv">
                  Di <b>{{ current_prov_clicked }}</b>
                </span>
              </div>
            </div>
            <div class="card-body">
              <div v-if="isShowProv" class="table-unggahan-terbaru">
                <loader-component v-if="post_data == null" />
                <post-list-simple-component v-else :posts="post_data" :key="post_key" :string_limit="130"
                  :link="true" />
                <pagination-component class="m-t-10 pull-right" v-if="post_page_info" :key="post_paging_key"
                  :data="post_page_info" />
              </div>
              <p v-else class="m-t-10">
                Silahkan pilih salah satu provinsi pada peta terlebih dahulu
              </p>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import $ from "jquery";
import page_header from "@/views/components/page_header.vue";
import bubble_maps_chart from "@/views/components/chart/bubble_maps_chart.vue";
import post_list_simple from "@/views/components/post_list_simple.vue";
import loader_component from "@/views/components/loader.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import pagination from "@/views/components/pagination.vue";
import gp from "@/plugins/generalPlugins.js";
import provinsi from "@/plugins/maps/countries/id-all.js";
import swal from "sweetalert";
import XLSX from "xlsx";
var table_config = {
  pageLength: 25,
  columnDefs: [{ width: "5%", targets: 0 }],
};
export default {
  name: "Maps",
  title: "Analitik Peta | Sibernetik",
  components: {
    "page-header-component": page_header,
    "bubble-maps-component": bubble_maps_chart,
    "post-list-simple-component": post_list_simple,
    "loader-component": loader_component,
    "table-dynamic-component": table_dynamic,
    "pagination-component": pagination,
  },
  data() {
    return {
      showCard: false,
      showPopular: false,
      isShowProv: false,
      filter_tier: "0",
      dataset: null,
      mapapi: null,
      current_prov_clicked: null,

      data_key: 0,
      table_key: 20,

      post_data: null,
      post_key: 10,

      akun_data: null,
      data_head:
        this.$store.getters.user.project.project_detail.display_tipe == 2 ||
          this.$store.getters.user.project.project_detail.display_tipe == 3
          ? ["No", "Media", "Berita"]
          : ["No", "Akun", "Followers", "Reach"],
      data_head_class: [
        {
          head: "No",
          class: "text-center",
        },
        {
          head: "Berita",
          class: "text-center",
        },
        {
          head: "Followers",
          class: "text-center",
        },
        {
          head: "Reach",
          class: "text-center",
        },
      ],
      table_config: table_config,
      akun_res: null,

      post_page_info: null,
      post_paging_key: 20,

      id_project: this.$store.getters.user.id_project,
      query: "",
      tooltip:
        "<p>Data yang ditampilkan pada maps hanya data dari twitter.</p>",

      filter_topic: this.$store.getters.filter_topic,
      topics: null,

      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,
      tour_steps: [],

      mounted: false,
      type_map:
        this.$store.getters.user.project.project_detail.display_tipe == 2 ||
          this.$store.getters.user.project.project_detail.display_tipe == 3
          ? "medkon"
          : "medsos",
      type_map_for_reset:
        this.$store.getters.user.project.project_detail.display_tipe == 2 ||
          this.$store.getters.user.project.project_detail.display_tipe == 3
          ? "Medkon"
          : "Medsos",
      title_map:
        this.$store.getters.user.project.project_detail.display_tipe == 2 ||
          this.$store.getters.user.project.project_detail.display_tipe == 3
          ? "Jumlah Mentions Media Online per Negara di Dunia"
          : "Jumlah Mentions Twitter per Negara di Dunia",
      data_provinsi: [],
      top_provinsi: [],
      topKey: 0,
    };
  },
  methods: {
    switchTab: function (component) {
      if (component == "Medkon") {
        this.title_map =
          "Jumlah Mentions Media Online per Negara di Dunia";
        this.type_map = "medkon";
        this.type_map_for_reset = "Medkon";
        this.isShowProv = false;
        this.showCard = false;
        this.showPopular = false;
        this.data_head = ["No", "Media", "Berita"];
      } else {
        this.title_map = "Jumlah Mentions Twitter per Negara di Dunia";
        this.type_map = "medsos";
        this.type_map_for_reset = "Medsos";
        this.isShowProv = false;
        this.showCard = false;
        this.showPopular = false;
        this.data_head = ["No", "Akun", "Followers", "Reach"];
      }
      this.getData();
      this.data_key++;
    },
    bubbleClicked: function (data, type = false) {
      if (!type) {
        this.current_prov_clicked = data.name;
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $("#popular-account").offset().top - 60,
          },
          1000
        );
        this.isShowProv = true;
        this.post_data = null;
        if ("page" in this.$route.query) {
          this.$route.query.page = 1;
        }
        this.getPost(data.hc_key);
        this.getAkun(data.hc_key);
      } else if (type && data.z != 0) {
        this.current_prov_clicked = data.name;
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $("#popular-account").offset().top - 60,
          },
          1000
        );
        this.showCard = true
        this.isShowProv = true;
        this.post_data = null;
        if ("page" in this.$route.query) {
          this.$route.query.page = 1;
        }
        this.getPost(data.hc_key, data.url);
        this.getAkun(data.hc_key, data.url);
      } else {
        this.current_prov_clicked = null
        this.showCard = false;
        this.isShowProv = false;
        this.showPopular = false;
        if (this.type_map == "medkon") {
          this.title_map =
            "Jumlah Mentions Media Online per Negara di Dunia";
        } else {
          this.title_map =
            "Jumlah Mentions Twitter per Negara di Dunia";
        }
        swal(
          "Data Tidak Ditemukan",
          "Mohon Maaf, data " + data.name + " tidak ditemukan",
          "warning"
        )
      }
    },
    getData: function () {
      var q = this.$route.query;
      let self = this;
      if ("from" in q) {
        let params = {
          from: this.$route.query.from,
          to: this.$route.query.to,
          tipesource: this.type_map,
        };
        if (this.type_map == "medkon") {
          params.tier = this.filter_tier;
        }
        if ("topic_selected" in this.$route.query) {
          params.topic_selected = this.$route.query.topic_selected;
        }
        if ("is_validated" in this.$route.query) {
          params.is_validated = this.$route.query.is_validated;
        }
        if ("cakupan" in this.$route.query) {
          params.cakupan = this.$route.query.cakupan;
        }
        if (this.filter_tier == "0") {
          delete params.tier;
        }
        let query = Object.keys(params)
          .map((key) => key + "=" + params[key])
          .join("&");
        if (query != this.query) {
          this.query = query;
          let api =
            process.env.VUE_APP_API_URL +
            "map/" +
            this.id_project +
            "?" +
            query;

          const objectsToAdd = [
            // indonesia
            { 'hc_key': 'id', 'z': 0 },
            // United State
            { 'hc_key': 'us', 'z': 0 },
            // Australia
            { 'hc_key': 'au', 'z': 0 },
            // New Zealand
            { 'hc_key': 'nz', 'z': 0 },
            // united kingdom
            { 'hc_key': 'gb', 'z': 0 },
            // Singapore
            { 'hc_key': 'sg', 'z': 0 },
            // Qatar
            { 'hc_key': 'qa', 'z': 0 },
            // Uni Emitrat Arab
            { 'hc_key': 'ae', 'z': 0 },
            // turkey
            { 'hc_key': 'tr', 'z': 0 },
            // rusia
            { 'hc_key': 'ru', 'z': 0 },
            // china
            { 'hc_key': 'cn', 'z': 0 },
            // france
            { 'hc_key': 'fr', 'z': 0 },
            // india
            { 'hc_key': 'in', 'z': 0 },
            // japan
            { 'hc_key': 'jp', 'z': 0 },
            // Africa
            { 'hc_key': 'za', 'z': 0 },
            // South Korea
            { 'hc_key': 'kr', 'z': 0 },
            // Germany
            { 'hc_key': 'de', 'z': 0 },
            // Thailand
            { 'hc_key': 'th', 'z': 0 },
            // Malaysia
            { 'hc_key': 'my', 'z': 0 },
            // Canada
            { 'hc_key': 'ca', 'z': 0 },
            // Myamar
            { 'hc_key': 'mm', 'z': 0 },
            // Italy
            { 'hc_key': 'it', 'z': 0 },
            // Geneva / Switzerland
            { 'hc_key': 'ch', 'z': 0 },
            // Belgium
            { 'hc_key': 'be', 'z': 0 },
            // Saudia Arab
            { 'hc_key': 'sa', 'z': 0 },
            // Taiwan
            { 'hc_key': 'tw', 'z': 0 },
            // Netherlands
            { 'hc_key': 'nl', 'z': 0 },
            // Brazil
            { 'hc_key': 'br', 'z': 0 },
            // Norway
            { 'hc_key': 'no', 'z': 0 },
            // Combodia
            { 'hc_key': 'kh', 'z': 0 }
          ];

          this.mapapi = api;
          this.$http
            .get(api)
            .then((response) => {
              if (response.status == 200) {
                // modify international data
                let result = {};
                response.data.forEach(value => {
                  if (!result[value.hc_key]) {
                    // Initialize if not present
                    // media internationl
                    if (value.url || value.province == false) {
                      result[value.hc_key] = {
                        hc_key: value.hc_key,
                        z: value.z,
                        url: value.url ? [value.url] : [],
                        province: value.province
                      };
                    } else {
                      result[value.hc_key] = value
                    }
                  } else {
                    // Add to existing entry
                    // media international
                    if (value.url || value.province == false) {
                      result[value.hc_key].z += value.z;
                      if (value.url) {
                        result[value.hc_key].url.push(value.url);
                      }
                    }
                  }
                });

                // dataset settings
                this.dataset = Object.values(result)
                objectsToAdd.forEach(object => {
                  const hc_keyExists = this.dataset.some(item => item.hc_key === object.hc_key);
                  if (!hc_keyExists) {
                    this.dataset.push(object);
                  }
                });
              } else {
                this.dataset = [];
              }
              this.data_key++;
            })
            .catch(function (err) {
              console.log(err);
            })
            .finally(function () {
              self.getProvinsi();
            });
        }
      }
    },
    getPost: function (province, url = null) {
      var params = this.$route.query;
      params.tier = this.filter_tier;
      params.items = 10;
      delete params.url;
      delete params.province;
      if (url != null) {
        params.url = url
      } else {
        params.province = province;
      }
      params.sources =
        this.type_map == "medkon"
          ? btoa("news,media_tv,media_cetak")
          : btoa("twitter");

      if (this.filter_tier == "0") {
        delete params.tier;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL + "posts/" + this.id_project + "?" + query;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.post_data = response.data.posts;
          } else {
            this.post_data = [];
          }
          this.post_key++;
          this.post_page_info = response.data.page_info;
          this.post_paging_key++;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getAkun: function (province, url = null) {
      var params = this.$route.query;
      var paramsTypeSouce = this.type_map == "medkon" ? "/medkon?" : "/socmed?";
      params.items = 100;
      params.tier = this.filter_tier;
      delete params.url
      delete params.province
      if (url != null) {
        params.url = url
      } else {
        params.province = province;
      }
      if ("page" in params) {
        delete params.page;
      }
      if (this.filter_tier == "0") {
        delete params.tier;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      this.akun_data = null;
      this.table_key++;
      let api =
        process.env.VUE_APP_API_URL +
        "influencers/" +
        this.id_project +
        paramsTypeSouce +
        query;
      this.$http.get(api).then((response) => {
        if (response.status == 200) {
          this.akun_res = response.data.accounts;
          this.akun_data = [];
          for (let index in response.data.accounts) {
            let akun = "";
            if (this.type_map == "medkon") {
              akun =
                '<a class="source-akun-clicked" href="#" data-index="' +
                index +
                '" data-id="' +
                response.data.accounts[index]._id +
                '">' +
                response.data.accounts[index].account +
                "</a>";
              this.akun_data.push([
                `<center>${parseInt(index) + 1}</center>`,
                akun,
                `<center>${response.data.accounts[index].mentions}</center>`,
              ]);
            } else {
              akun =
                '<a class="source-akun-clicked" href="#" data-index="' +
                index +
                '" data-id="' +
                response.data.accounts[index]._id +
                '">@' +
                response.data.accounts[index].account +
                "</a>";
              this.akun_data.push([
                `<center>${parseInt(index) + 1}</center>`,
                akun,
                `<center>${response.data.accounts[index].followers}</center>`,
                `<center>${response.data.accounts[index].esmr}</center>`,
              ]);
            }
          }
          this.table_key++;
        } else {
          this.akun_data = [];
        }
      });
    },
    filterChange: function () {
      this.getData();
      if ("page" in this.$route.query && "province" in this.$route.query) {
        this.getPost(this.$route.query.province);
      }
    },
    getTopic: function () {
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.topics = response.data;
          } else {
            this.topics = {};
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getData();
        });
    },
    showPost(index) {
      let account = this.akun_res[index];
      this.$router.push({
        path: "/detail-akun",
        query: { account: account.account, key: btoa(account._id) },
      });
    },
    getProvinsi: function () {
      // if (this.showCard == true) {
      let prov = provinsi.load_data();
      this.data_provinsi = [];
      this.top_provinsi = [];
      for (let feature in prov.features) {
        for (let data in this.dataset) {
          if (
            this.dataset[data].hc_key ==
            prov.features[feature].properties.hc_key
          ) {
            this.data_provinsi.push({
              nama_provinsi: prov.features[feature].properties.name,
              count: this.dataset[data].z,
            });
          }
        }
      }
      this.data_provinsi.sort(function (a, b) {
        return b.count - a.count;
      });
      for (let i = 0; i < 10; i++) {
        if (this.data_provinsi[i] != null) {
          this.top_provinsi.push(this.data_provinsi[i]);
        }
      }
      this.topKey++;
      // }
    },
    getDataExcel: function () {
      this.$store.dispatch("loading", true);
      var topik = XLSX.utils.json_to_sheet(this.data_provinsi);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, topik, "Maps");
      XLSX.writeFile(wb, "Maps.xlsx");
      this.$store.dispatch("loading", false);
    },
    thousandSeparator(value) {
      return gp.thousandSeparator(value);
    },
    filterTierChange() {
      this.getData();
      this.getPost();
      this.getAkun();
    },
  },
  filters: {
    date_time_to_indo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
  },
  watch: {
    $route() {
      if ("page" in this.$route.query && "province" in this.$route.query) {
        this.getPost(this.$route.query.province);
      } else if ("page" in this.$route.query && "url" in this.$route.query) {
        this.getPost(this.$route.query.province, this.$route.query.url);
      }
    },
  },
  created: function () {
    this.getTopic();
  },
  mounted: function () {
    this.mounted = true;
    let self = this;
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("body").offset().top,
      },
      1000
    );
    $("#popular-account").on("click", ".source-akun-clicked", function (e) {
      e.preventDefault();
      let index = $(this).attr("data-index");
      self.showPost(index);
    });

    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: "#tab",
      header: {
        title: "Berpindah Tab",
      },
      content: `Anda dapat berpindah tab dengan melakukan klik pada media online atau media sosial.`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#mapcontainer",
      header: {
        title: "Peta Sebaran Pengguna Twitter",
      },
      content:
        "Jumlah postingan disetiap provinsi direpresentasikan oleh bulatan pada peta. Semakin besar bulatannya menunjukan semakin banyak postingan dari provinsi tersebut. Anda dapat melakukan klik pada bulatan provinsi untuk melihat detail postingan dan akun pada provinsi tersebut.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#top-provinsi",
      header: {
        title: "Top 10 Provinsi",
      },
      content:
        "Menampilkan daftar 10 provinsi dengan mention terbanyak dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#popular-account",
      header: {
        title: "Akun Terpopuler",
      },
      content:
        "Akan menampilkan daftar akun terpopuler di kota yang dipilih dengan jumlah berita yang di posting dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#unggahan-terbaru",
      header: {
        title: "Unggahan Terbaru",
      },
      content:
        "Akan menampilkan unggahan terbaru di kota yang dipilih dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    this.tour_steps = v_step;
  },
};
</script>

<style scoped>
.provinsiFloat {
  position: relative;
  z-index: 1;
}

.provinsiFloat .cardFloat {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 300px;
  box-shadow: rgba(100, 100, 111, 0.478) 0px 7px 29px 0px;
  padding: 8.5px;
}

.col-md-25 {
  width: 20% !important;
}
</style>
